import React, { useEffect } from 'react';
import { makeStyles, TextField, FormControl } from '@material-ui/core';
import { t } from 'src/shared/literals';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '200px',
    margin: theme.spacing(1)
  }
}));

const FormDate = ({ field, handleChangeField }) => {
  const classes = useStyles();
  const { name, value, errorMessage, readonly } = field;

  const handleChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    handleChangeField(e);
  };

  return (
    <FormControl className={classes.formControl} key={name}>
      <TextField
        error={Boolean(errorMessage)}
        helperText={t(errorMessage)}
        label={t(name.toString())}
        margin="normal"
        name={name}
        onBlur={() => {}}
        onChange={handleChange}
        InputProps={{
          readOnly: readonly
        }}
        type="date"
        value={moment(value).format('yyyy-MM-DD')}
        variant="outlined"
        className={classes.textField}
      />
    </FormControl>
  );
};

export default FormDate;
